export default "__VITE_ASSET__12304959__"